import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Admin from './Admin';
import Debug from './Debug';
import ProxyHandler from './ProxyHandlerSimple';
import { AuthProvider } from './keycloak'; // Versión de producción con Keycloak
import { LanguageProvider } from './LanguageContext';
import Layout from './Layout';

import './index.css'; // Tailwind debe estar importado aquí

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            {/* Rutas proxy sin layout */}
            <Route path="/proxy" element={<ProxyHandler />} />
            
            {/* Rutas con layout */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<App />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/debug" element={<Debug />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);
